import cn from "classnames";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
}

export const Watermark: React.FC<Props> = ({ className, ...otherProps }) => {
	return (
		<div
			className={cn("font-bold text-md text-gray", className)}
			{...otherProps}
		>
			epsmomentum.com
		</div>
	);
};
